import * as Yup from 'yup';

export const validationSchema = (isCopy, isAdmin) =>
  Yup.object().shape({
    name: Yup.string()
      .max(50, 'Maximum length is 50 characters')
      .required('Mobile Configuration name is required'),
    description: Yup.string().max(50, 'Maximum length is 50 characters'),
    scrollTopMin: Yup.number()
      .required('Scroll to top is required')
      .integer('Scroll to top must be an integer'),
    desiredUserId:
      isCopy && isAdmin ? Yup.string().required('Username is required') : null,
  });
